export const axiosRequestInterceptor = {
  onFulfilled: config => {
    // const token = 'getToken';

    //   add token to header
    const modifyHeaders = {
      headers: {
        Accept: 'application/json'
        // Authorization: `Bearer ${token}`
      }
    };
    config = { ...config, ...modifyHeaders };

    return config;
  },
  onRejected: error => {
    return Promise.reject(error);
  }
};

export const axiosResponseInterceptor = {
  onFulfilled: res => {
    if (res.status === 200) return res;
  },
  onRejected: error => {
    let errorIs = error?.message;

    if (error?.response && error.response.status === 401) {
      errorIs = 'unauthorized, 401';
    }

    return Promise.reject(`request failed: ${errorIs}`);
  }
};
